<div mat-dialog-content>
    <div class="flex justify-center items-center flex-col">
        <mat-spinner></mat-spinner>
        <p>{{ data.message || '' }}</p>
    </div>
</div>
